import { z } from 'zod';

import { PlaceIdParamsSchema } from '../customer/place-customer.schemas.js';

export const FISCAL_NUMBER_VOIDING_STATUSES = ['PENDING', 'APPROVED', 'REJECTED', 'ERROR'] as const;

export const FiscalNumberVoidingIdParamsSchema = z.looseObject({
  id: z.uuid(),
});

export const ListFiscalNumberVoidingsParamsSchema = PlaceIdParamsSchema;

export const ListFiscalNumberVoidingsQuerySchema = z.looseObject({
  status: z.enum(FISCAL_NUMBER_VOIDING_STATUSES).optional(),
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).optional(),
});

export const RequestFiscalNumberVoidingBodySchema = z.object({
  documentKind: z.enum(['NFE', 'NFCE']),
  series: z.number().int().positive(),
  year: z.number().int().min(2000).max(2099),
  startNumber: z.number().int().positive(),
  endNumber: z.number().int().positive(),
  justification: z.string().min(15).max(255),
});

export const FiscalNumberVoidingResponseSchema = z.looseObject({
  numberVoidingId: z.uuid(),
  status: z.enum(FISCAL_NUMBER_VOIDING_STATUSES),
  inFlight: z.boolean(),
  series: z.number().int(),
  year: z.number().int(),
  startNumber: z.number().int(),
  endNumber: z.number().int(),
  protocolNumber: z.string().nullable().optional(),
  lastErrorCode: z.string().nullable().optional(),
  lastErrorMessage: z.string().nullable().optional(),
  placeId: z.uuid().optional(),
  documentKind: z.enum(['NFE', 'NFCE']).optional(),
  environment: z.enum(['HOMOLOGATION', 'PRODUCTION']).optional(),
  justification: z.string().optional(),
  artifactReferences: z.record(z.string(), z.string()).optional(),
  gapRecordedAt: z.iso.datetime().nullable().optional(),
  dispatchedAt: z.iso.datetime().nullable().optional(),
  createdAt: z.iso.datetime().optional(),
  updatedAt: z.iso.datetime().optional(),
});

export const FiscalNumberVoidingListItemSchema = z.looseObject({
  numberVoidingId: z.uuid(),
  documentKind: z.enum(['NFE', 'NFCE']),
  environment: z.enum(['HOMOLOGATION', 'PRODUCTION']),
  series: z.number().int(),
  year: z.number().int(),
  startNumber: z.number().int(),
  endNumber: z.number().int(),
  status: z.enum(FISCAL_NUMBER_VOIDING_STATUSES),
  inFlight: z.boolean(),
  protocolNumber: z.string().nullable(),
  lastErrorCode: z.string().nullable(),
  lastErrorMessage: z.string().nullable(),
  gapRecordedAt: z.iso.datetime().nullable(),
  createdAt: z.iso.datetime(),
});

export const ListFiscalNumberVoidingsResponseSchema = z.looseObject({
  items: z.array(FiscalNumberVoidingListItemSchema),
  pagination: z.looseObject({
    cursor: z.string().nullable(),
    hasMore: z.boolean(),
    limit: z.number().int().positive(),
  }),
});

export type RequestFiscalNumberVoidingBody = z.infer<typeof RequestFiscalNumberVoidingBodySchema>;
export type FiscalNumberVoidingResponse = z.infer<typeof FiscalNumberVoidingResponseSchema>;
export type ListFiscalNumberVoidingsQuery = z.infer<typeof ListFiscalNumberVoidingsQuerySchema>;
export type ListFiscalNumberVoidingsResponse = z.infer<
  typeof ListFiscalNumberVoidingsResponseSchema
>;
